module.exports = __webpack_public_path__ + "ae5d11b7d08ef442a8fc9f3b858b2bf2.pdf";